import { CAMPOS_GENERALES, CAMPOS_ESPECIFICOS } from "../schemas/fichaSchema";
import { CAMPOS_GENERALES_FASE, CAMPOS_ESPECIFICOS_FASE } from "../schemas/faseSchema";
import { buildPrefillCamposGenerales, esValorVacio } from "../../helpers/solicitudFichaPrefill";

export const extraerCamposFormulario = ({ flujo, tipoFormulario, data, solicitud  }) => {
    if (flujo === "FICHA") {
        return extraerFicha(tipoFormulario, data, solicitud);
    }
    if (flujo === "FASE") {
        return extraerFase(tipoFormulario, data);
    }
    return {};
};


const obtenerValor = (campo) => {
    if (!campo) return '';
    if (typeof campo === 'object' && campo.valor !== undefined) {
        return campo.valor;
    }
    return campo;
};


const mapearCampos = (listaCampos, data) => {
    return listaCampos.reduce((acc, campo) => {
        acc[campo] = obtenerValor(data[campo]);
        return acc;
    }, {});
    };


// ----------------------
// FICHAS DE SEGUIMIENTO 
// ----------------------

const extraerFicha = (tipoFormulario, data, solicitud) => {
    const generales = extraerGeneralesFicha(data, solicitud);
    const especificos = extraerEspecificosFicha(tipoFormulario, data);
    const resultado = {
        ...generales,
        ...especificos
    };
    if (data.sesiones) {
        resultado.sesiones = data.sesiones;
    }
    return resultado;
};


const extraerGeneralesFicha = (data, solicitud) => {
    const prefill = buildPrefillCamposGenerales(solicitud);
    const generalesMapeados = CAMPOS_GENERALES.reduce((acc, campo) => {
        const desdeFormulario = obtenerValor(data[campo]);
        const desdeSolicitud = prefill[campo];
        acc[campo] = !esValorVacio(desdeFormulario)
            ? desdeFormulario
            : (desdeSolicitud !== undefined && desdeSolicitud !== null ? desdeSolicitud : '');
        return acc;
    }, {});

    const ur = solicitud?.usuario_registro || {};
    const nombreCompleto = [ur.primer_nombre, ur.segundo_nombre, ur.primer_apellido, ur.segundo_apellido]
        .filter((p) => p != null && String(p).trim() !== '')
        .join(' ')
        .trim();

    return {
        nombre_completo: nombreCompleto,
        documento_id: solicitud?.usuario_registro?.identificacion || '',
        ...generalesMapeados,
    };
};

const extraerEspecificosFicha = (tipoFormulario, data) => {
    const campos = CAMPOS_ESPECIFICOS[tipoFormulario] || [];
    return mapearCampos(campos, data);
};



// -------
// FASES
// -------

const extraerFase = (tipoFormulario, data) => {
    const generales = extraerGeneralesFase(data);
    const especificos = extraerEspecificosFase(tipoFormulario, data);
    return {
        ...generales,
        ...especificos
    };
    };


const extraerGeneralesFase = (data) => {
    return mapearCampos(CAMPOS_GENERALES_FASE, data);
};


const extraerEspecificosFase = (tipoFormulario, data) => {
    const campos = CAMPOS_ESPECIFICOS_FASE[tipoFormulario] || [];
    const especificos = mapearCampos(campos, data);

    if (tipoFormulario === 'F5_007') {
        const valorVoluntad = especificos.voluntad_restaurativa;
        if (typeof valorVoluntad === 'string') {
            const normalizado = valorVoluntad.trim().toUpperCase();
            if (normalizado === 'SI') especificos.voluntad_restaurativa = true;
            if (normalizado === 'NO') especificos.voluntad_restaurativa = false;
        }
    }

    return especificos;
};


